package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.attestation.AttestationDTO
import gr.tech.GRAttestation.navigation.AdminSitePage
import gr.tech.GRAttestation.sections.admin.AdminTableContainer
import gr.tech.GRAttestation.styles.grstyles.BPlaceholder
import gr.tech.GRAttestation.styles.grstyles.DefaultTableHeaderStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.TimeUtils.formatDateOnly
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*


@Composable
fun AdminAttestationsSummaryTable(
    attestations: List<AttestationDTO>,
) {
   AdminTableContainer(
        modifier = Modifier.fillMaxHeight()
    ) {
        Table(
            attrs = Modifier
                .classNames("table")
                .fillMaxWidth()
                .toAttrs()
        ) {
            Thead(
                attrs = Modifier
                    .styleModifier {
                        property("table-layout", "fixed")
                    }
                    .toAttrs()
            ) {
                Tr {
                    listOf(
                        "To Store",
                        "Rep Name",
                        "Sign Date",
                        "Created At",
                    ).forEach { header ->
                        Th(
                            attrs = DefaultTableHeaderStyle.toModifier()
                                .classNames("col").toAttrs()
                        ) { Text(header) }
                    }
                }
            }
            Tbody {
                if (attestations.isNotEmpty()) {
                    attestations.forEach { form ->
                        AdminAttestationSummaryRow(form,)
                    }
                } else {
                    repeat(2) {
                        AdminAttestationSummaryRow(null)
                    }
                }
            }
        }
    }
}


@Composable
fun AdminAttestationSummaryRow(
    attestation: AttestationDTO?,
) {
    Tr(Modifier.height(57.px).toAttrs()) {
        attestation?.let { attestation ->
            Td(
                attrs = Modifier.maxWidth(250.px).whiteSpace(WhiteSpace.NoWrap)
                    .textOverflow(TextOverflow.Ellipsis).overflow(Overflow.Hidden).toAttrs()
            ) {
                Link(
                    path = AdminSitePage.Stores.passStoreId(attestation.storeId.toString()),
                    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                    modifier = Modifier.textDecorationLine(TextDecorationLine.Underline).color(Theme.DarkGreen.rgb).cursor(Cursor.Pointer)
                ) {
                    Text(attestation.storeName)
                }
            }
            Td { Text(attestation.repName) }
            Td {
                Span { Text(formatDateOnly(attestation.dateSigned)) }
            }
            Td {
                Span { Text(formatDateOnly(attestation.createdAt)) }
                TableDateTimeTooltip(attestation.createdAt)
            }
        } ?: run {
            Td { BPlaceholder(Modifier.width(200.px)) }
            Td { BPlaceholder(Modifier.width(100.px)) }
            Td { BPlaceholder() }
            Td { BPlaceholder() }
        }
    }
}